import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';

// 1. Define the mutation
const mutation = gql`
  mutation incrementGymPlayFriendGamesWon($input: IncrementGymPlayFriendGamesWonInput!) {
    incrementGymPlayFriendGamesWon(input: $input) {
      _id
      userId
      gameType
      opponentName
      played
      won
    }
  }
`;

// 2. Define TypeScript types for input and return shape
export interface IncrementGymPlayFriendGamesWonInput {
  opponentName: string;
  gameType: GAME_TYPES_TYPE;
  userId: string;
}

export interface GymPlayFriendGame {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  opponentName: string;
  played: number;
  won: number;
}

export interface MutationType {
  incrementGymPlayFriendGamesWon: GymPlayFriendGame;
}

// 3. Create the hook
export function useIncrementGymPlayFriendGamesWonMutation(
  options?: MutationHookOptions<MutationType, { input: IncrementGymPlayFriendGamesWonInput }>,
) {
  return useMutation<MutationType, { input: IncrementGymPlayFriendGamesWonInput }>(
    mutation,
    options,
  );
}
